import { BASE_PATH } from '../../../paths';

const CLIENT_BASE_PATH = `${BASE_PATH}/client`;
export const CLIENT_PATHS = {
  personal: `${CLIENT_BASE_PATH}/personal`,
  occupation: `${CLIENT_BASE_PATH}/occupation`,
};
